import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SortableList } from '../../components/form/SortedBy'
import { fetchShowcaseSort } from '../../redux/slices/showcaseSortSlice'
import { fetchShowcaseDelete } from '../../redux/slices/showcaseDeleteSlice'
import CrudNews from './CrudNews'
import { fetchShowcaseGetAllByNews } from '../../redux/slices/showcaseGetAllByNewsSlice'

const NewsPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const news = useSelector((state) => state.showcaseGetAllByNews.data)
    const status = useSelector((state) => state.showcaseGetAllByNews.status)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchShowcaseGetAllByNews())
        setChanged(false)
    }

    const handleSorted = (newList) => {
        news.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchShowcaseSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchShowcaseDelete({ id: id }))
        getData()
    }

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("news_management")}
                description={t("news_management_desc")}
                buttonText={t("add_news")}  
            />

            {status === "succeeded" ?
                <SortableList
                    setModal={setModal}
                    list={news ? [...news].sort((a, b) => a.sort - b.sort) : []}
                    onChange={handleSorted}
                    setChanged={setChanged}
                    deleteData={deleteData}
                    setSelectedItem={setSelectedItem}
                /> : null
            }

            <CrudNews
                showMenu={modal}
                setShowMenu={setModal}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                t={t}
            />
        </CMS>
    )
}

export default NewsPage
